import { getUnit } from '../../store/utils';

const CREATE_UNITS_ASC = [
    { label: (p: number) => `${p} ${getUnit('days', p.toString())}`, unit: 'days' },
    { label: (p: number) => `${p} ${getUnit('weeks', p.toString())}`, unit: 'weeks' },
    { label: (p: number) => `${p} ${getUnit('months', p.toString())}`, unit: 'months' },
    { label: (p: number) => `${p} ${getUnit('years', p.toString())}`, unit: 'years' },
];

const CREATE_FREQUENCY_UNITS_ASC = [
    { label: (p: number) => `${p} time in a Day` },
    { label: (p: number) => `${p} time in a Week` },
    { label: (p: number) => `${p} time in a Month` },
    { label: (p: number) => `${p} time in a Year` },
];

export enum LAB_TESTS_FOLLOWUP_TIME_TYPE {
    MID_DAY = 'mid-day',
    PRESENT_TIME = 'present-time',
    YESTERDAY = 'yesterday',
    DAY_BEFORE_YESTERDAY = 'day-before-yesterday',
    TOMORROW = 'tomorrow',
    DAY_AFTER_TOMORROW = 'day-after-tomorrow',
}

export enum LAB_TESTS_FOLLOWUP_DATE_TYPE {
    HOUR = 'hour',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
}

export const CREATE_LAB_TESTS_TEST_ON_UNITS = [
    {
        label: 'days',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.DAY,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'hours',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.HOUR,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.PRESENT_TIME,
    },
    {
        label: 'weeks',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.WEEK,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
];

export const CREATE_LAB_TESTS_REPEAT_ON_UNITS = [
    {
        label: 'days',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.DAY,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'weeks',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.WEEK,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'months',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.MONTH,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
];

export const CREATE_DENTAL_EXAMINATIONS_SINCE_UNITS = [
    {
        label: 'days',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.DAY,
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'weeks',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.WEEK,
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'months',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.MONTH,
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'years',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.YEAR,
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
];

export const CREATE_DENTAL_PROCEDURES_START_ON_UNITS = [
    {
        label: 'days',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.DAY,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'weeks',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.WEEK,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
    {
        label: 'months',
        type: LAB_TESTS_FOLLOWUP_DATE_TYPE.MONTH,
        prefix: 'After',
        timeType: LAB_TESTS_FOLLOWUP_TIME_TYPE.MID_DAY,
    },
];

const START_FROM_UNITS_ASC = [
    { label: (p: number) => `From day ${p}`, unit: 'day' },
    { label: (p: number) => `From week ${p}`, unit: 'week' },
    { label: (p: number) => `From month ${p}`, unit: 'month' },
];

const TO_DAY_UNITS_ASC = [
    { label: (p: number) => `To day ${p}`, unit: 'day' },
    { label: (p: number) => `To week ${p}`, unit: 'week' },
    { label: (p: number) => `To month ${p}`, unit: 'month' },
];

const STATUS_UNITS = [
    { label: 'yes', unit: 'yes' },
    { label: 'no', unit: 'no' },
];

const DURATION_EXTRA_OPTIONS = ['To continue', 'Till required'];

export const generateOptions = (
    wholeOptions: { label: (p: number) => string; unit?: string }[],
    extraOptions?: string[],
) => (newValue: string): { id: string; label: string; value: string; meta: unknown }[] => {
    const t = newValue.trim();

    if (!t) {
        return [];
    }

    const n = t.split(' ');

    const pi = parseFloat(n[0]);

    if (isNaN(pi)) {
        return extraOptions
            ? extraOptions.map((option) => ({
                  id: option,
                  label: option,
                  value: option,
                  meta: {},
              }))
            : [];
    }

    return wholeOptions.map((c) => ({
        id: `${pi}-${c.unit}`,
        label: c.label(pi),
        value: c.label(pi),
        meta: {
            unit: c.unit,
            input: pi.toString(),
        },
    }));
};

export const generateFrequencyOptions = generateOptions([
    { label: (p: number) => `${p} time in a Hour` },
    ...CREATE_FREQUENCY_UNITS_ASC,
]);

export const generateStatusOptions = STATUS_UNITS;

export const generateSinceOptions = generateOptions([
    { label: (p: number) => `${p} ${getUnit('hours', p.toString())}`, unit: 'hours' },
    ...CREATE_UNITS_ASC,
]);
export const generateDurationOptions = generateOptions(CREATE_UNITS_ASC, DURATION_EXTRA_OPTIONS);
export const generateStartFromOptions = generateOptions(START_FROM_UNITS_ASC);
export const generateToDayOptions = generateOptions(TO_DAY_UNITS_ASC);
